"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyForCsv = exports.stringify = void 0;
const unicode_1 = require("./unicode");
// Replacer that keeps bigints JSON-serializable and decodes \uXXXX escapes so
// that non-ASCII content (e.g. Japanese ingested with Python ensure_ascii=True)
// renders as real characters instead of escape sequences.
const stringifyReplacer = (_key, value) => {
    if (typeof value === "bigint")
        return Number.parseInt(value.toString());
    if (typeof value === "string")
        return (0, unicode_1.decodeUnicodeEscapesOnly)(value, true);
    return value;
};
const stringify = (data, key, indent) => {
    // For comment fields, use pretty-print formatting for better readability
    // Other fields use compact format to reduce file size, unless an explicit
    // indent is requested by the caller (e.g. human-readable trace downloads).
    const resolvedIndent = indent ?? (key === "comments" ? 2 : undefined);
    return JSON.stringify(data, stringifyReplacer, resolvedIndent);
};
exports.stringify = stringify;
/**
 * CSV-specific stringify that returns strings as-is instead of JSON-encoding them.
 * This avoids double-encoding when string fields (e.g. JSON input/output from ClickHouse)
 * are passed through JSON.stringify and then CSV-escaped.
 */
const stringifyForCsv = (data, key) => {
    if (typeof data === "string")
        return (0, unicode_1.decodeUnicodeEscapesOnly)(data, true);
    return (0, exports.stringify)(data, key);
};
exports.stringifyForCsv = stringifyForCsv;
